<div *ngIf="images !== undefined && images.length > 0" class="container">
  <img id="image" [src]="imagePath" />
  <div class="datetime-wrapper">
    <div class="date"><span>{{ now | date: 'EEEE, d MMMM' }}</span></div>
    <div class="time"><span>{{ now | date: 'shortTime' }}</span></div>
  </div>
</div>

<div *ngIf="(images !== undefined && images.length === 0)" class="no-images">
  <div>No images to display</div>
  <div>Press back button to exit</div>
</div>
